/**
 * Labor that landed on no claim — `FactClaimAllocations` rows with `ClaimID = "No
 * Claim"` — as the crosstab names it in its facility, facility-group, state and
 * payer-type columns. Same string as NO_CLAIM in scripts/build_bundle.py.
 *
 * It used to share "Unknown" with real claims whose facility did not resolve, which
 * put $7.1M of unattributed payroll over ~2,300 claims and drew a $1,500 cost per claim
 * for a facility group that does not exist. It is payroll with no claim behind it: no
 * facility, no rate, and nothing to drill to but the payroll itself
 * (`Dataset.unattributedMonths`).
 */
export const NO_CLAIM = 'No claim (unattributed labor)'

/** Whether a slicer value is the no-claim bucket rather than a facility, state or payer. */
export const isNoClaim = (v: string | null | undefined): boolean => v === NO_CLAIM
